import { getScrollPosition, getScrollSmoother } from '@lib/tools/scroll/scrollPosition';

export const handleBodyLock = () => {
  if (Object.hasOwn(document.body.dataset, 'bodyScrollFix')) return;

  const scrollPosition = getScrollPosition();
  document.body.dataset.bodyScrollFix = String(scrollPosition);

  const smoother = getScrollSmoother();

  if (smoother) {
    smoother.paused(true);
    const wrapper = document.getElementById('smooth-wrapper');
    if (wrapper) wrapper.style.overflow = 'hidden';
    return;
  }

  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.left = '0';
  document.body.style.width = '100%';
};
